import firebase from "datastore/database";
import store from "datastore/store";

export default function observeTags(businessUid) {
  store.dispatch({ type: "ADD_TAGS_LOADING" });
  return firebase
    .firestore()
    .collection("tags/business/" + businessUid)
    .onSnapshot((doc) => {
      const data = doc.docs
        .map((doc) => ({ uid: doc.id, ...doc.data() }))
        .map((section) => {
          let tags = Object.entries(section.tags).map((entry) => {
            // We changed the schema, so do a lil magic here
            const [uid, data] = entry;
            if (typeof data === "string") {
              return { uid, name: data };
            }
            return { uid, ...data };
          });
          return { ...section, tags };
        });
      store.dispatch({ type: "ADD_TAGS_SUCCESS", data });
    });
}
